module.exports = __webpack_public_path__ + "static/media/SignUp_background.f4831eb9.jpg";